import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './lib/animate/animate.min.css';
import './lib/lightbox/css/lightbox.min.css';
import './lib/owlcarousel/assets/owl.carousel.min.css';
import './css/bootstrap.min.css';
import './css/style.css';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// import MarketPage from "./screens/market_page";
import MarketPage from "./pages/market_page_n";
import HomePage from "./home_page";
import HomepageV2 from "./pages/HomePageV2"
import Test from "./test";
// import StockPage from "./stock_page";
import StockPage from "./stock_page_n";
// import NewsPage from "./pages/news";
import NewsPage from "./pages/newsPage";
import IAPage from "./pages/ia_page"
import RAPage from "./pages/ra_page";
import SSPage from "./pages/ss_page";
import SigPage from "./pages/sig_page";
import MFPage from "./pages/mf_page";
import Login from "./components/userlogin";
import PortfolioPage from "./pages/portfolio_page";
import StockHome from "./pages/stock_home";
import QuantPage from "./pages/quant_page";
import NewsPage1 from "./stockhome";
import ResearchPage from "./pages/research_page";
import LoginPage from "./login_page";
import RegisterPage from "./register_page";
import OS from "./os";
import MarketOptionS from "./components/options/marketoptions_strategy";
import OSPage from "./pages/os_page";
import TBDPage from "./tbd";
import FundamentalPage from "./pages/stock_fundamental_page";
import Blog from "./pages/blog_page";
import Privacypolicy from "./pages/privacy_page";
import About from "./pages/about_page";
import Contact from "./pages/contact_page";
import LegalPage from "./pages/legal_page";
import SSDetailPage from "./pages/ss_detail_page";
import Subscription from "./pages/subscription_page";
import VideoModal from "./components/ui/video";
import Signaltable from "./components/signaltable";
import SignalDetailPage from "./components/signals/signalDetailPage";
import SigDetailPage from "./pages/sig_detail_page";
import MFHome from "./pages/MFHome";
import MFHomeStandalone from "./pages/MFHomeStandalone";
import FundExplorerStandalone from "./pages/FundExplorerStandalone";
import FundDetailsStandalone from "./pages/FundDetailsStandalone";
import MarketInsightsStandalone from "./pages/MarketInsightsStandalone";
import FundExplorerPage from "./pages/FundExplorerPage";
import FundDetailPage from "./pages/FundDetailPage";
import MFPartnersPage from "./pages/MFPartnersPage";
import NewsArticlePage from "./pages/NewsArticlePage";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomepageV2 />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage/>} />
        <Route path="/marketpage" element={<MarketPage />} />
        <Route path="/stock/" element={<StockHome />} />
        <Route path="/stock/:symbol" element={<StockPage />} />
        <Route path="/news/" element={<NewsPage />} />
        <Route path="/news/article/:id" element={<NewsArticlePage />} />

        <Route path="/ia/" element={<IAPage />} />
        <Route path="/os/" element={<OSPage />} />
        <Route path="/ra/" element={<RAPage />} />
        <Route path="/ss/" element={<SSPage />} />
        <Route path="/ss/:key" element={<SSDetailPage />} />
        <Route path="/ssi/" element={<SigPage />} />
        <Route path="/ssi/:signal_key" element={<SigDetailPage />} />
        {/*<Route path="/mf/:mfsymbol" element={<MFPage />} />*/}
        {/*<Route path="/mf/" element={<MFPage />} />*/}
        <Route path="/mf/" element={<MFHomeStandalone />} />
        <Route path="/mfe/" element={<FundExplorerPage />} />
        <Route path="/mfd/:isin" element={<FundDetailPage />} />
        <Route path="/mfpartners/" element={<MFPartnersPage />} />

        {/*<Route path="/mfe/" element={<FundExplorerStandalone />} />*/}
        <Route path="/fd/" element={<FundDetailsStandalone />} />
        <Route path="/mfi/" element={<MarketInsightsStandalone />} />
        <Route path="/portfolio/" element={<PortfolioPage />} />
        <Route path="/quant/" element={<QuantPage />} />
        <Route path="/research/" element={<ResearchPage />} />
        <Route path="/myportfolio/" element={<PortfolioPage />} />
        <Route path="/fd/:symbol" element={<FundamentalPage />} />
        <Route path="/tbd" element={<TBDPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/privacy_policy" element={<Privacypolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/subscription" element={<Subscription />} />

        <Route path="/test" element={<Test />} />
        {/*<Route path="/returns" element={<ReturnsPage />} />*/}
        {/*<Route path="/strategies" element={<StrategiesPage />} />*/}
        {/*<Route path="/rates" element={<RatesPage />} />*/}
      </Routes>
    </Router>
  );
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />

  </React.StrictMode>
);

// const marketsnapshotRoot = document.getElementById('marketsnapshot-root');
// if (marketsnapshotRoot) {
//   ReactDOM.createRoot(marketsnapshotRoot).render(
//     <React.StrictMode>
//         <marketsnapshot />
//     </React.StrictMode>
//   );
// }
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
